// extracted by mini-css-extract-plugin
module.exports = {"main-component":"testingLoading_main-component__vpfrz"};